import { useTheme } from "@mui/material";
import { Data, IBarValue } from "components/BarsChartFailureCodes/BarsValueInterfaces";
import { localeFormattedNumber } from "utilities/utilities";

const ReportSummaryLayer = ({ bars, xScale }: IBarValue) => {
    const themeStyles = useTheme();
    const xValues: number[] = [];
    const yValues: number[] = [];
    return bars.map(({ data: { data, indexValue }, y, height }: Data, i: number) => {
        const total = Object.values(data).map((value) => value);
        if (xValues.includes(xScale(typeof total[0] === "number" ? Number(total[0]) : 0)) && yValues.includes(y)) {
            return <g key={`${indexValue}-${i}`} />;
        }
        xValues.push(xScale(total[0] as number));
        yValues.push(y);

        return (
            <g
                transform={`translate(${xScale(typeof total[0] === "number" ? Number(total[0]) : 0)})`}
                key={`${indexValue}-${i}`}
            >
                <text
                    className="bar-total-label"
                    fontFamily="Open Sans"
                    fontSize={12}
                    fontWeight={600}
                    x={height - height / 1.1}
                    y={y + height / 2}
                    textAnchor="start"
                    alignmentBaseline="central"
                    style={{
                        fill: themeStyles.palette.text.primary,
                    }}
                >
                    {typeof total[0] === "number" ? localeFormattedNumber(data.countryCode as string, total[0]) : 0}
                </text>
            </g>
        );
    });
};

export default ReportSummaryLayer;
